

export  const gondereninSorumluluklari = [
    {
        id:1,
        text: "Taşıma ile ilgili gerekli belgeleri (araç ruhsatı, ehliyet, SRC, araç yetki belgesi vb.) almak ve araçların bir yetki belgesine kayıtlı olup olmadığını kontrol etmekle sorumludur."
    },
    {
        id:2,
        text: "Bulundurulması, satılması, sevk edilmesi ve ticareti kanunen yasak olan bir eşya gönderilemez, taşıyıcı da bunu taşıyamaz. Aksi takdirde gönderen ve taşıyıcı sorumludur."
    },
    {
        id:3,
        text: "Yükü; ilgili kanun ve diğer mevzuatlara uygun bir şekilde taşıyıcıya teslim etmek; kayıp ve hasardan koruyacak ve taşıyıcıya zarar vermeyecek şekilde ambalajlamak; taşıma güvenliğine uygun biçimde araca istiflemek, bağlamak, sabitleyerek yüklemek ve aynı şekilde boşaltmak zorundadır. Bunlardan doğacak zararlardan gönderen sorumludur."
    },
    {
        id:4,
        text: "Tonaj ve gabari aşımından gönderen ve taşıyıcı müştereken sorumludur."
    },
    {
        id:5,
        text: "Eşyanın cinsi, miktarı, niteliği, istifleme şekli, kalkış ve varış noktası, alıcının adı ve adresi ile kimliğini ibraz etmek suretiyle önemli bilgileri eksiksiz olarak taşıyıcıya bildirmek zorundadır. Yanlış ve eksik bildirimlerden doğacak tüm sorumluluk gönderene aittir."
    },
    {
        id:6,
        text: "Taşıma ücreti; farklı bir süre belirtilmediği takdirde; gönderici yada alıcı tarafından; yükün teslimi sonrası, en kısa sürede ödenecektir."
    },
    {
        id:7,
        text: "Tehlikeli eşya taşınacaksa; gönderen, taşıyıcıya, zamanında, açık, anlaşılabilir ve yazılı şekilde, tehlikenin türü ve alınması gereken önlemler konusunda bildirimde bulunmakla yükümlüdür. Bu bildirim yapılmadığında doğacak tüm zararlardan gönderen sorumludur."
    },
    {
        id:8,
        text: "Taşıma sırasında; alıcının yada varış yerinin değiştirilmesi, malın göndericiye iadesi yada yükün belli bir depoda bekletilmesi talep edilebilir. Taşıyıcı, gönderenin yazılı talebine uymakla yükümlüdür. Teslim yerinin değiştirilmesi vb.  nedenlerle taşıma giderlerinde değişiklik yada ek maliyet olursa, gönderen yada alıcı bu gideri karşılamak zorundadır."
    },
    {
        id:9,
        text: "Taşıyıcı, kendinden kaynaklanmayan nedenlerle makul yükleme ve/veya boşaltma süresinden daha fazla beklerse, uygun bir bekleme ücretine hak kazanır. Bundan gönderici ve alıcı sorumludur."
    },
    {
        id:10,
        text: "Gönderici adına yükü teslim eden ve imzalayan gönderici yetkilisi de bu maddelerden müteselsilen sorumludur."
    }
  ]

  export const tasiyicininSorumluluklari = [
    {
        id: 1,
        text: "İlgili kanun ve mevzuat hükümlerine uygun; teknik şartları sağlayan ve bir yetki belgesine sahip araç/araçlar ile ehliyet ve yeterlik belgesine sahip; yeterli sayıda nitelikli sürücülerle; taşıma işini yapacaktır."
    },
    {
        id: 2,
        text: "Teslim aldığı yükü/eşyayı; taşıma senedinde belirtilen veya ticari teamüllerle belirlenen bir süre zarfında veya özenli bir taşıyıcıya tanınabilecek makul bir sürede; güvenli bir şekilde taşımak ve alıcıya hasarsız ve eksiksiz olarak teslim etmekle yükümlüdür."
    },
    {
        id: 3,
        text: "Teslim aldığı yükü/eşyayı; sıcağa, soğuğa, ısı değişikliklerine, neme, sarsıntılara ya da benzer etkilere karşı özel olarak korumakla yükümlüdür. Hâl ve şartlara göre; özellikle de gerekli donanımın seçiminde, bakımında ve kullanımında; kendisine düşen tüm önlemleri aldığını ve özel talimatlara uygun davrandığını ispat ederek sorumluluktan kurtulabilir."
    },
    {
        id: 4,
        text: "Yükün teslim alınmasından teslim edilmesine kadar geçecek süre içinde; yükün tamamen yada kısmen kaybından, çalınmasından, emniyeti/güveni suistimalden, hasarından veya teslimindeki kendinden kaynaklı gecikmelerde doğan tüm zararlardan taşıyıcı sorumludur. Zararın doğmasına taşıyıcının adamları sebep olmuşsa bu durumda da taşıyıcı zarara kendi sebep olmuş gibi sorumludur."
    },
    {
        id: 5,
        text: "Taşıyıcı; yükün bedeli üzerinde teminatla “Taşıyıcı Sorumluluk Sigortası” yaptıracaktır. Teminatı aşan kısmından taşıyıcı sorumludur."
    },
    {
        id: 6,
        text: "Taşıyıcı, bir ihbar veya şüphe halinde yetkili ve görevlilerin huzurunda yükü/eşyayı kontrol ettirebilir."
    },
    {
        id: 7,
        text: "Yüke ait sevk irsaliyesini yükle birlikte götürmek, muhafaza etmek ve alıcıya imzalatmakla sorumludur."
    },
    {
        id: 8,
        text: "Taşıyıcının kusuru ile taşıma işi yarım kalmış ise taşıyıcı taşıma ücreti isteyemez."
    },
    {
        id: 9,
        text: "Taşıyıcı; İş sağlığı ve güvenliği, çevre kirliliğini önleme, çevre ve insan sağlığını koruma konusundaki kurallara ve mevzuat hükümlerine uymak ve gereken her türlü tedbiri almak zorundadır."
    },
  ]

  export const alicininSurumluluklari = [
    {
        id: 1,
        text: "Yükü teslim aldıktan sonra taşıma senedindeki bilgileri eksiksiz olarak doldurmak ve imzalamakla sorumludur."
    },
    {
        id: 2,
        text: "Eksik yada hasarlı teslimat durumunda, bunu durumu sürücüyle birlikte kayıt altına almakla sorumludur."
    },
    {
        id: 3,
        text: "Boşaltmada yaşanan, alıcı kaynaklı bekleme ve gecikmeden dolayı yükün zarar görmesinden alıcı sorumludur."
    },
  ]

  export const acenteninSorumluluklari = [
    {
        id:1,
        text: "Taşıma ile ilgili gerekli belgeleri (araç ruhsatı, ehliyet, SRC, araç yetki belgesi vb.) almak ve araçların bir yetki belgesine kayıtlı olup olmadığını kontrol etmekle sorumludur."
    },
    {
        id:2,
        text: "Acenteler; bu sıfatla yapmış oldukları faaliyet ve işlemlerden taşıyıcı ile müştereken ve müteselsilen sorumludur."
    }
  ]

